<template>
  <v-card flat >
    <vuex-loader :request-id='reqId' ></vuex-loader>
    <v-card-title>
        <v-layout>
          <v-flex >
            <h3 class='headline'>Take bookings online!</h3>
            <p class='subheading'>
            Your clients can book online from your free AppointmentGuru website, your booking widget or via the mobile app. This frees up your time with less phone calls and messages for appointments.
            </p>
          </v-flex>
          <v-flex hidden-xs-only >
            <img class='mr-3'
              alt='Example website and app listing'
              width='170'
              src='https://media-appointmentguru.s3.amazonaws.com/media/practitioner/logo/170_get-online-example.png' />
          </v-flex>
        </v-layout>
    </v-card-title>

      <v-divider></v-divider>
      <v-list three-line >
        <v-subheader class='overline' >
          Configure how you would like your customers to book
        </v-subheader>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>language</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Booking widget</v-list-tile-title>
            <v-list-tile-sub-title>
              <a :href='bookingwidget' target='_blank' >{{bookingwidget}}</a>
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              Share the direct link to let someone book online with you, or embed it on your website
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action >
            <v-btn :href='bookingwidget' class='mt-2' target='_blank' icon >
              <v-icon>open_in_new</v-icon>
            </v-btn>
            <v-list-tile-action-text>
              View
            </v-list-tile-action-text>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-dialog width='350' v-model='showembedcode' >
              <v-card>
                <v-card-title class='subtitle-1 overline' >
                  Copy this code to embed a booking widget in your website
                </v-card-title>
                <v-card-text>
                  <v-textarea outlined outline readonly persistent-hint
                    v-model='embedCode' style='font-size:small'
                    label='Embed this in your website'
                    height='200'
                    hint='Paste this code where you would like to embed the booking widget' >
                  </v-textarea>
                  <v-divider ></v-divider>
                  <copy-text-field
                    class='mt-4'
                    :text-to-copy='bookingwidget'
                    label='Share your online booking form'
                    hint='Share this link to enable your clients to easily book online with you' >
                  </copy-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions >
                  <v-btn @click='showembedcode=false' small flat text >Close</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn :href='bookingwidget' target='_blank' small text flat >
                    Show widget
                    <v-icon small>open_in_new</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn @click='showembedcode=true' icon>
              <v-icon>code</v-icon>
            </v-btn>
            <v-list-tile-action-text>
              Embed
            </v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-checkbox v-model='webEnabled' :disabled='saveRequest.loading' ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Your website </v-list-tile-title>
            <v-list-tile-sub-title>
              Your website URL:
              <a :href="website" target='_blank' >{{website}}</a>
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-if='!webPublished' >
              Currently disabled. Check the box on the left to enable and configure
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else >
              Configure your website below
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn class='mt-2' :disabled='!webPublished' :href='website' target='_blank' icon >
              <v-icon>open_in_new</v-icon>
            </v-btn>
            <v-list-tile-action-text>
              View
            </v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
        <!-- <v-list-tile>
          <v-list-tile-action>
            <v-checkbox v-model='appEnabled' :disabled='saveRequest.loading' ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content >
            <v-list-tile-title>List in AppointmentGuru mobile app</v-list-tile-title>
            <v-list-tile-sub-title>
              Allows your clients to book and manage appointments from the
              <a href='https://getapp.guru/' target='_blank' >AppointmentGuru mobile app for your clients</a>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile> -->
      </v-list>
      <v-card flat >
        <v-card-title class='overline' >Configure your website</v-card-title>
        <v-alert
          v-if='!webPublished' type='info' :value='true' outline >
          You website is currently disabled. You need to enable it in order to configure.
          <v-btn
            @click='webEnabled=true;save()'
            :loading='saveRequest.loading'
            outline outlined small >Turn on website</v-btn>
        </v-alert>
        <v-text-field
          v-else
          outline outlined
          :loading='actionRequest.loading'
          v-model='subdomain'
          @click:append='setSubdomain'
          @keyup.enter='setSubdomain'
          :error='actionRequest.status > 399'
          :success='actionRequest.status === 200'
          :success-messages='subdomainSuccessMessage'
          :error-messages='subdomainErrorMessage'
          label='Set your website url' prefix='appt.guru/' append-icon='save' >
        </v-text-field>
        <unsplash-search v-if='webPublished' ></unsplash-search>
      </v-card>

  </v-card>
</template>

<script>
import UnsplashSearch from './UnsplashSearch'
import CopyTextField from '@/components/ui/CopyTextField'

export default {
  name: 'Online',
  components: {UnsplashSearch, CopyTextField},
  data () {
    return {
      resource: 'practitioner.me.profile',
      reqId: 'practitioner-settings-update',
      webEnabled: false,
      appEnabled: false,
      showembedcode: false,
      newsubdomain: '',
      actionRequest: {
        loading: false, status: 0, data: {}
      }
    }
  },
  methods: {
    save () {
      let payload = {
        is_website_published: this.webEnabled,
        is_visible_in_app: this.appEnabled
      }
      this.$appointmentguru
        .resource(this.resource)
        .id(this.reqId)
        .save(this.me.id, payload)
    },
    setSubdomain () {
      this.action(
        this.$appointmentguru,
        'practitioner',
        'practitioners',
        this.me.id,
        'set_subdomain',
        {sub_domain: this.newsubdomain},
        this.actionRequest
      )
    }
  },
  computed: {
    me () {
      return this.$store.getters.me
    },
    webPublished () {
      return this.me.profile.is_website_published
    },
    appLive () {
      return this.me.profile.is_website_published
    },
    subdomainSuccessMessage () {
      if (this.actionRequest.status === 200) {
        return [
          'Successfully updated your URL'
        ]
      }
      return []
    },
    subdomainErrorMessage () {
      if (this.actionRequest.status > 399) {
        if (this.actionRequest.result.sub_domain) {
          return this.actionRequest.result.sub_domain
        }
      }
      return []
    },
    subdomain: {
      get () {
        return this.getObjectPath(this.me, 'profile.sub_domain', null)
      },
      set (val) {
        this.newsubdomain = val
      }
    },
    website () {
      if (this.subdomain) {
        return `http://appt.guru/${this.subdomain}/`
      }
      return ''
    },
    bookingwidget () {
      return 'https://widget.appt.guru/?practitioner=' + this.meId
    },
    saveRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    actionRequestStatus () {
      return this.actionRequest.status
    },
    embedCode () {
      return `<iframe
   src="${this.bookingwidget}”
   style="border: 0px;box-shadow: 0 1px 3px rgba(0,0,0,.2),0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)!important;"
   width="100%" height="400px" >
</iframe>`
    }
  },
  mounted () {
    this.webEnabled = this.me.profile.is_website_published
    this.appEnabled = this.me.profile.is_visible_in_app
  },
  watch: {
    webPublished () {
      this.webEnabled = this.me.profile.is_website_published
    },
    appLive () {
      this.appEnabled = this.me.profile.is_visible_in_app
    },
    webEnabled () {
      this.save()
    },
    appEnabled () {
      this.save()
    },
    actionRequestStatus () {
      if (this.actionRequestStatus === 200) {
        this.getMe()
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.getMe()
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Online.vue?1506de86